// extracted by mini-css-extract-plugin
export default {"conversationBlock":"Conversations_conversationBlock__lJnCP","description":"Conversations_description__pon8B","subscribeButton":"Conversations_subscribeButton__9A-cr"};